import React from 'react'
import classNames from './index.scss'
import '@yaireo/tagify/dist/tagify.css'
import config from 'config'
import WebAppIframe from '../../../components/WebAppIframe'

class B2BOffersReportIFrame extends React.Component {
  render() {
    return (
      <div style={{width: '100%', margin: '0 auto'}}>
        <WebAppIframe src={`${config.casaWebAppUrl}/b2b-offers-report`} id="iframe" className={`${classNames.iframe}`} />
      </div>
    )
  }
}

export default B2BOffersReportIFrame



// WEBPACK FOOTER //
// ./src/routes/B2BOffersReport/containers/index.js